import { Spinner } from 'react-bootstrap'
import { EventGroup } from './types'
import { EventDateGroup } from './EventDateGroup'
import { TimelineConnector } from './TimelineConnector'
import { ActivityV2 } from 'models/activityV2'
interface EventHistoryListProps {
  isLoading: boolean
  error: unknown
  groupedEvents: EventGroup[]
  hasNextPage?: boolean
  isFetchingNextPage: boolean
  fetchNextPage: () => void
  onPreviewRequest: (sampleId: number) => void
  onEmailClick?: (event: ActivityV2) => void
}

export function EventHistoryList({
  isLoading,
  error,
  groupedEvents,
  hasNextPage,
  isFetchingNextPage,
  fetchNextPage,
  onPreviewRequest,
  onEmailClick,
}: EventHistoryListProps) {
  return (
    <div className="relative min-h-[100px]">
      {/* Error state */}
      {!!error && (
        <div className="py-8 text-center text-sm text-red-500">
          Failed to load event history
        </div>
      )}

      {/* Empty state */}
      {!error && groupedEvents.length === 0 && !isLoading && (
        <div className="py-8 text-center text-sm text-gray-500">
          No recent events found
        </div>
      )}

      {/* Content */}
      {!error && groupedEvents.length > 0 && (
        <div className="mt-4 space-y-6 relative">
          {/* Timeline connector - simple CSS line behind icons */}
          <TimelineConnector />

          {/* Event groups */}
          {groupedEvents.map((group) => (
            <EventDateGroup
              key={group.date}
              group={group}
              onPreviewRequest={onPreviewRequest}
              onEmailClick={onEmailClick}
            />
          ))}

          {/* Load More Button */}
          {hasNextPage && (
            <div className="flex justify-center pt-4 pb-8">
              <button
                onClick={() => fetchNextPage()}
                disabled={isFetchingNextPage}
                className="px-6 py-2 bg-fb-dark-green text-white rounded-lg hover:bg-fb-dark-green-hover transition-colors disabled:opacity-50 disabled:cursor-not-allowed flex items-center gap-2"
              >
                {isFetchingNextPage ? (
                  <>
                    <Spinner animation="border" size="sm" />
                    <span>Loading...</span>
                  </>
                ) : (
                  <span>Load More Events</span>
                )}
              </button>
            </div>
          )}
        </div>
      )}

      {/* Loading overlay for tab/search switching (when we have previous data) */}
      {isLoading && (
        <div className="absolute inset-0 bg-white/70 backdrop-blur-sm flex items-center justify-center z-50 rounded">
          <Spinner animation="border" size="sm" />
        </div>
      )}
    </div>
  )
}
